// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WhatsApp · Plataforma — reuses .plp-* tokens from PlataformaPagos.css. */

.pli-kapso {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
  text-decoration: none;
  border-bottom: 1px solid var(--border);
}
.pli-kapso:hover {
  color: var(--text);
}

/* ── tarjeta: el resumen es el botón que abre el detalle ── */
.plp-card.pli-card {
  cursor: pointer;
}
.pli-card__open {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.pli-card__open:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 4px;
}
.pli-card__open .plp-card__fields {
  display: grid;
}
.pli-card__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.pli-card__actions .pli-kapso {
  margin-left: auto;
}

/* The pedido open in the detail (?id=), from a click or the Slack alert. */
.plp-card.is-selected,
.plp-card.is-selected:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
}

/* On --accent-soft the field labels keep AA contrast with the deep accent. */
.plp-card.is-selected .plp-cf__l {
  color: var(--accent-deep);
}

/* ── detalle ── */
.pli-detail {
  padding: 0 24px 96px;
}
.pli-detail__bar {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 4px;
}
.pli-detail__back,
.pli-detail__close {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  background: var(--bg-alt);
  color: var(--text-secondary);
  font-family: var(--mono);
  font-size: var(--fs-xs);
  cursor: pointer;
}
.pli-detail__back {
  margin-right: auto;
}
.pli-detail__close {
  min-width: 32px;
  justify-content: center;
  font-size: var(--fs-ui);
}
.pli-detail__back:hover,
.pli-detail__close:hover {
  color: var(--text);
}
.pli-detail__head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.pli-detail__title {
  margin: 0;
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-title-sm);
  font-weight: 400;
  color: var(--text);
  overflow-wrap: anywhere;
}
.pli-detail__title:focus {
  outline: none;
}
.pli-detail__title:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 4px;
}
.pli-detail__dates {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 32px;
  margin: 4px 0 0;
}
.pli-detail__dates dd {
  margin: 0;
}
.pli-detail__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-soft);
}
.pli-detail__msg {
  padding-top: 20px;
}
.pli-detail__text {
  margin: 0;
  font-size: var(--fs-body);
  line-height: 1.5;
  color: var(--text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.pli-detail__note {
  margin: 10px 0 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.pli-detail__prompt {
  margin: 0;
  padding: 32px 24px;
  max-width: 44ch;
  font-size: var(--fs-ui);
  color: var(--text-muted);
}

/* Desde 1024px: la cola a la izquierda con su propio scroll y el detalle a la
   derecha. Bajo eso, una sola columna: la cola o el detalle. */
/* Closing a pedido whose card is not on screen leaves focus on the queue. */
.pli-queue:focus {
  outline: none;
}
.pli-queue:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

@media (min-width: 1024px) {
  /* The workspace is as tall as the viewport below the sticky Topbar, minus
     the page's bottom padding, and each column scrolls on its own. Scrolled
     to the end, the page leaves the workspace right under the Topbar, so no
     column can slide beneath it. Sticky columns cannot do this: they size
     the grid themselves, which leaves them no room to stick. */
  .pli-workspace {
    display: grid;
    grid-template-columns: 360px minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
    height: max(
      320px,
      calc(100dvh - var(--lb-topbar-h, 52px) - var(--s-20, 80px))
    );
    margin-top: 12px;
    border-top: 1px solid var(--border);
  }
  .pli-queue,
  .pli-workspace > .pli-detail {
    min-height: 0;
    overflow-y: auto;
  }
  /* The focused title stops below the Topbar when the page scrolls to it. */
  .pli-detail__title {
    scroll-margin-top: var(--lb-topbar-h, 52px);
  }
  .pli-queue {
    padding-top: 16px;
    border-right: 1px solid var(--border);
  }
  .pli-queue .plp-cards,
  .pli-queue .plp-more {
    padding-left: 16px;
    padding-right: 16px;
  }
  .pli-queue .plp-empty {
    margin: 0 16px;
  }
  .pli-workspace > .pli-detail {
    padding-left: 32px;
    padding-right: 32px;
  }
  .pli-detail__msg,
  .pli-detail__head,
  .pli-detail__note {
    max-width: 72ch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/PlataformaWhatsApp.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,2EAA2E;AAC3E;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,6EAA6E;AAC7E;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;+DAC+D;AAC/D,4EAA4E;AAC5E;EACE,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;;;;+DAI6D;EAC7D;IACE,aAAa;IACb,2CAA2C;IAC3C,kCAAkC;IAClC;;;KAGC;IACD,gBAAgB;IAChB,mCAAmC;EACrC;EACA;;IAEE,aAAa;IACb,gBAAgB;EAClB;EACA,0EAA0E;EAC1E;IACE,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;EACA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/* WhatsApp · Plataforma — reuses .plp-* tokens from PlataformaPagos.css. */\n\n.pli-kapso {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  text-decoration: none;\n  border-bottom: 1px solid var(--border);\n}\n.pli-kapso:hover {\n  color: var(--text);\n}\n\n/* ── tarjeta: el resumen es el botón que abre el detalle ── */\n.plp-card.pli-card {\n  cursor: pointer;\n}\n.pli-card__open {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.pli-card__open:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 4px;\n}\n.pli-card__open .plp-card__fields {\n  display: grid;\n}\n.pli-card__actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n.pli-card__actions .pli-kapso {\n  margin-left: auto;\n}\n\n/* The pedido open in the detail (?id=), from a click or the Slack alert. */\n.plp-card.is-selected,\n.plp-card.is-selected:hover {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n}\n\n/* On --accent-soft the field labels keep AA contrast with the deep accent. */\n.plp-card.is-selected .plp-cf__l {\n  color: var(--accent-deep);\n}\n\n/* ── detalle ── */\n.pli-detail {\n  padding: 0 24px 96px;\n}\n.pli-detail__bar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 0 4px;\n}\n.pli-detail__back,\n.pli-detail__close {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  background: var(--bg-alt);\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  font-size: var(--fs-xs);\n  cursor: pointer;\n}\n.pli-detail__back {\n  margin-right: auto;\n}\n.pli-detail__close {\n  min-width: 32px;\n  justify-content: center;\n  font-size: var(--fs-ui);\n}\n.pli-detail__back:hover,\n.pli-detail__close:hover {\n  color: var(--text);\n}\n.pli-detail__head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n.pli-detail__title {\n  margin: 0;\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-title-sm);\n  font-weight: 400;\n  color: var(--text);\n  overflow-wrap: anywhere;\n}\n.pli-detail__title:focus {\n  outline: none;\n}\n.pli-detail__title:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 4px;\n}\n.pli-detail__dates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 32px;\n  margin: 4px 0 0;\n}\n.pli-detail__dates dd {\n  margin: 0;\n}\n.pli-detail__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-soft);\n}\n.pli-detail__msg {\n  padding-top: 20px;\n}\n.pli-detail__text {\n  margin: 0;\n  font-size: var(--fs-body);\n  line-height: 1.5;\n  color: var(--text);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.pli-detail__note {\n  margin: 10px 0 0;\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n}\n.pli-detail__prompt {\n  margin: 0;\n  padding: 32px 24px;\n  max-width: 44ch;\n  font-size: var(--fs-ui);\n  color: var(--text-muted);\n}\n\n/* Desde 1024px: la cola a la izquierda con su propio scroll y el detalle a la\n   derecha. Bajo eso, una sola columna: la cola o el detalle. */\n/* Closing a pedido whose card is not on screen leaves focus on the queue. */\n.pli-queue:focus {\n  outline: none;\n}\n.pli-queue:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: -2px;\n}\n\n@media (min-width: 1024px) {\n  /* The workspace is as tall as the viewport below the sticky Topbar, minus\n     the page's bottom padding, and each column scrolls on its own. Scrolled\n     to the end, the page leaves the workspace right under the Topbar, so no\n     column can slide beneath it. Sticky columns cannot do this: they size\n     the grid themselves, which leaves them no room to stick. */\n  .pli-workspace {\n    display: grid;\n    grid-template-columns: 360px minmax(0, 1fr);\n    grid-template-rows: minmax(0, 1fr);\n    height: max(\n      320px,\n      calc(100dvh - var(--lb-topbar-h, 52px) - var(--s-20, 80px))\n    );\n    margin-top: 12px;\n    border-top: 1px solid var(--border);\n  }\n  .pli-queue,\n  .pli-workspace > .pli-detail {\n    min-height: 0;\n    overflow-y: auto;\n  }\n  /* The focused title stops below the Topbar when the page scrolls to it. */\n  .pli-detail__title {\n    scroll-margin-top: var(--lb-topbar-h, 52px);\n  }\n  .pli-queue {\n    padding-top: 16px;\n    border-right: 1px solid var(--border);\n  }\n  .pli-queue .plp-cards,\n  .pli-queue .plp-more {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .pli-queue .plp-empty {\n    margin: 0 16px;\n  }\n  .pli-workspace > .pli-detail {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n  .pli-detail__msg,\n  .pli-detail__head,\n  .pli-detail__note {\n    max-width: 72ch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
